import React from "react";
import { SiBmw, SiAudi, SiVolkswagen, SiVolvo, SiFord, SiRenault, SiPeugeot, SiPorsche, SiToyota } from "react-icons/si";

const BRANDS = [
  { Icon: SiBmw, name: "BMW" },
  { Icon: SiAudi, name: "Audi" },
  { Icon: SiVolkswagen, name: "Volkswagen" },
  { Icon: SiPorsche, name: "Porsche" },
  { Icon: SiVolvo, name: "Volvo" },
  { Icon: SiFord, name: "Ford" },
  { Icon: SiRenault, name: "Renault" },
  { Icon: SiPeugeot, name: "Peugeot" },
  { Icon: SiToyota, name: "Toyota" },
];

export const BrandStrip = () => (
  <section className="px-6 md:px-12 py-14 border-t border-white/5" data-testid="brand-strip">
    <p className="text-center font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-500 mb-9">
      Toutes marques · +40 constructeurs supportés
    </p>
    <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-8 max-w-4xl mx-auto">
      {BRANDS.map(({ Icon, name }) => (
        <div key={name} className="group" title={name}>
          <Icon className="w-10 h-10 text-zinc-400 group-hover:text-aurora-cyan transition-colors duration-300" />
        </div>
      ))}
    </div>
  </section>
);
